export const LIST_FEATURES = {
  COMPANY_PROFILE_TRADING_AREA: 'COMPANY_PROFILE_TRADING_AREA',
  PEOPLE_SEARCH_OVERVIEW: 'PEOPLE_SEARCH_OVERVIEW',
  COMPARE_COMPANY_RESULT: 'COMPARE_COMPANY_RESULT',
  TARIFFS_AND_RULES_RESULT: 'TARIFFS_AND_RULES_RESULT',
  COMPANY_PROFILE_NEGATIVE_MEDIA: 'COMPANY_PROFILE_NEGATIVE_MEDIA',
  COMPANY_PROFILE_TRADEMARK: 'COMPANY_PROFILE_TRADEMARK',
  COMPANY_PROFILE_ALERT: 'COMPANY_PROFILE_ALERT',
  COMPANY_PROFILE_DATA_ANALYTICS: 'COMPANY_PROFILE_DATA_ANALYTICS',
  COMPANY_PROFILE_SUPPLY_CHAIN_MAP: 'COMPANY_PROFILE_SUPPLY_CHAIN_MAP',
  COMPANY_PROFILE_BILL_OF_LADING: 'COMPANY_PROFILE_BILL_OF_LADING',
  COMPANY_PROFILE_HS_CODE: 'COMPANY_PROFILE_HS_CODE',
  COMPANY_PROFILE_CUSTOMERS: 'COMPANY_PROFILE_CUSTOMERS',
  COMPANY_PROFILE_SUPPLIERS: 'COMPANY_PROFILE_SUPPLIERS',
  COMPANY_PROFILE_COMPETITORS: 'COMPANY_PROFILE_COMPETITORS',
  COMPANY_PROFILE_PORTS_OF_DELIVERY: 'COMPANY_PROFILE_PORTS_OF_DELIVERY',
  COMPANY_PROFILE_PORTS_OF_ORIGIN: 'COMPANY_PROFILE_PORTS_OF_ORIGIN',
  PEOPLE_SEARCH_COMPANY_RELATED: 'PEOPLE_SEARCH_COMPANY_RELATED',
  PEOPLE_SEARCH_PEOPLE_RELATED: 'PEOPLE_SEARCH_PEOPLE_RELATED',
  PEOPLE_SEARCH_ALERTS: 'PEOPLE_SEARCH_ALERTS',
  COMPANY_PROFILE_EMAIL_VALIDATION: 'COMPANY_PROFILE_EMAIL_VALIDATION',
  PEOPLE_SEARCH_EMAIL_VALIDATION: 'PEOPLE_SEARCH_EMAIL_VALIDATION',
  TRADE_DATA_BILL_OF_LADING: 'TRADE_DATA_BILL_OF_LADING',
  TRADE_DATA_MARKET_ANALYTICS: 'TRADE_DATA_MARKET_ANALYTICS',
  TRADE_DATA_SUPPLIER_COUNTRY: 'TRADE_DATA_SUPPLIER_COUNTRY',
  TRADE_DATA_BUYER_COUNTRY: 'TRADE_DATA_BUYER_COUNTRY',
  TRADE_DATA_PORT_OF_ORIGIN: 'TRADE_DATA_PORT_OF_ORIGIN',
  TRADE_DATA_PORT_OF_DELIVERY: 'TRADE_DATA_PORT_OF_DELIVERY',
  TRADE_DATA_SUPPLIERS: 'TRADE_DATA_SUPPLIERS',
  TRADE_DATA_BUYERS: 'TRADE_DATA_BUYERS',
  INTERNAL_TRADE_DATA_TRADE_INSIGHTS: 'INTERNAL_TRADE_DATA_TRADE_INSIGHTS',
  INTERNAL_TRADE_DATA_UNIT_PRICES: 'INTERNAL_TRADE_DATA_UNIT_PRICES',
  INTERNAL_TRADE_DATA_SUB_LIST_SUPPLIERS_BUYERS: 'INTERNAL_TRADE_DATA_SUB_LIST_SUPPLIERS_BUYERS',
  COMPANY_PROFILE_COMPANY_OVERVIEW: 'COMPANY_PROFILE_COMPANY_OVERVIEW',
  COMPANY_PROFILE_ADDRESS: 'COMPANY_PROFILE_ADDRESS',
  COMPANY_PROFILE_CONTACTS: 'COMPANY_PROFILE_CONTACTS',
  COMPANY_PROFILE_REVIEWS: 'COMPANY_PROFILE_REVIEWS',
  COMPANY_PROFILE_SOCIAL_MEDIA: 'COMPANY_PROFILE_SOCIAL_MEDIA',
  COMPANY_PROFILE_WEB_DETAILS: 'COMPANY_PROFILE_WEB_DETAILS',
  INTERNAL_COMPANY_PROFILE_TRADE_INSIGHTS: 'INTERNAL_COMPANY_PROFILE_TRADE_INSIGHTS',
  INTERNAL_COMPANY_PROFILE_SUB_LIST_SUPPLIERS_BUYERS: 'INTERNAL_COMPANY_PROFILE_SUB_LIST_SUPPLIERS_BUYERS',
  REPORT_TRADE_DATA: 'REPORT_TRADE_DATA',
  INTERNAL_REPORT_COMPANY_DUE_DILIGENCE: 'INTERNAL_REPORT_COMPANY_DUE_DILIGENCE',
  AI_HS_CODE_LABELING: 'AI_HS_CODE_LABELING',
} as const;

export const LIST_ACTIONS = {
  VIEW: 'points_view',
  PRINT: 'points_print',
  DOWNLOAD: 'points_download',
} as const;

export enum FeatureAction {
  VIEW = 'view',
  DOWNLOAD = 'download',
  PRINT = 'print',
}
